import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cart-widget__items" }

import CartItem from '@/classes/CartItem';
import AppCartItem from '@/components/cart/AppCartItem.vue';
import AppCartItemInternet from '@/components/cart/AppCartItemInternet.vue';
import {
  computed,
} from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppCartItems',
  setup(__props) {

const store = useStore();

const cartItems = computed<Array<CartItem>>(() => store.getters['cart/all']);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartItems.value, (cartItem) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: cartItem.key
      }, [
        (!cartItem.product.isInternet)
          ? (_openBlock(), _createBlock(AppCartItem, {
              key: 0,
              product: cartItem.product,
              "item-key": cartItem.key,
              onRemove: ($event: any) => (_ctx.$.emit('remove', cartItem.key, cartItem.product))
            }, null, 8, ["product", "item-key", "onRemove"]))
          : _createCommentVNode("", true),
        (cartItem.product.isInternet)
          ? (_openBlock(), _createBlock(AppCartItemInternet, {
              key: 1,
              product: cartItem.product,
              "item-key": cartItem.key,
              onRemove: ($event: any) => (_ctx.$.emit('remove', cartItem.key, cartItem.product))
            }, null, 8, ["product", "item-key", "onRemove"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})